<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import { getSiteBaseUrl } from '@/lib/siteBaseUrl'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

defineProps<{
	content: {
		title: string
		description: string
		buttonText: string
		buttonLink: string
		items: {
			title: string
			link: string
			icon: string
		}[]
	}
}>()

const isShowOnboardingPage = localStorage.getItem('show_onboarding_page')

const handleItemClick = (index: number, link: string) => {
	const ITEMS = ['Shipment', 'Shopping', 'Not Sure', 'Skip']

	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: GaGeneralPageName.UserPreferencePage,
		button_name: ITEMS[index],
	})

	window.location.href = link
}

const clearOnboardingFlag = () => {
	localStorage.removeItem('show_onboarding_page')
}

onMounted(() => {
	if (!isShowOnboardingPage) {
		const baseUrl = getSiteBaseUrl()
		window.location.href = import.meta.env.DEV
			? `${import.meta.env.PUBLIC_ROOT_URL}/index`
			: baseUrl
	}

	window.addEventListener('beforeunload', clearOnboardingFlag)
})

onUnmounted(() => {
	window.removeEventListener('beforeunload', clearOnboardingFlag)
})
</script>

<template>
	<div v-if="isShowOnboardingPage">
		<header class="border-b border-n-100 py-24px">
			<div class="bs-container flex h-24px justify-center mdp:justify-start">
				<BaseIcon
					name="company_logo_primary"
					class="col-span-12 h-24px w-[156px] fill-o-500"
				/>
			</div>
		</header>
		<div class="bs-container">
			<div class="col-span-12">
				<section
					class="mx-auto py-acquaintances text-center text-n-950 mdp:max-w-[592px]"
				>
					<div class="typography-h3-str mb-8px">{{ content.title }}</div>
					<div class="typography-s1-reg text-n-500">
						{{ content.description }}
					</div>

					<div class="flex flex-col gap-16px py-casual-friends mdp:gap-20px">
						<div
							v-for="(item, index) in content.items"
							:key="item.title"
							class="flex cursor-pointer items-center gap-12px rounded-[12px] bg-o-50 px-12px py-24px mdp:gap-20px mdp:border mdp:border-n-100 mdp:bg-white mdp:px-24px mdp:py-12px can-hover:hover:bg-o-75 mdp:can-hover:hover:bg-o-50"
							@click="handleItemClick(index, item.link)"
						>
							<div class="h-[48px] w-[64px] mdp:h-[80px] mdp:w-[106px]">
								<BaseIcon
									:name="item.icon"
									class="h-[48px] w-[64px] fill-o-500 mdp:h-[80px] mdp:w-[106px]"
								/>
							</div>

							<div data-metric-section class="typography-s1-reg text-start">
								{{ item.title }}
							</div>

							<div class="ml-auto h-24px w-24px">
								<BaseIcon name="chevron_v1" class="h-24px w-24px fill-o-500" />
							</div>
						</div>
					</div>

					<button
						class="typography-l1-emp border-b py-4px"
						@click="handleItemClick(3, content.buttonLink)"
					>
						{{ content.buttonText }}
					</button>
				</section>
			</div>
		</div>
	</div>
</template>
